import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { Competency } from 'src/app/common/models/competency';
import { CompetencyService } from 'src/app/common/services/competency.service';

@Component({
    selector: 'app-year-end-reflections-competency',
    templateUrl: './year-end-reflections-competency.component.html',
    styleUrls: ['./year-end-reflections-competency.component.css'],
    standalone: false
})
export class YearEndReflectionsCompetencyComponent implements AfterViewInit  {

  @ViewChild('f') form: NgForm;

  @Input() competency: Competency;
  @Input() finalReflectionStatus: string;

  constructor(private competencyService: CompetencyService){}

  ngAfterViewInit(): void {
    if(this.finalReflectionStatus === "Available"){
      this.form.valueChanges.pipe(debounceTime(500)).subscribe(() =>{
        const scrubbedCompetency = this.competencyService.scrubCompetency(this.competency);
        this.competencyService.updateCompetency(scrubbedCompetency).subscribe();
      });
    }
  }
}
